module.exports = __webpack_public_path__ + "static/media/PA-Icon-T├╝r-pos.1b3665a1.svg";